import { GET_ZONE_RATE_FAILURE, GET_ZONE_RATE_REQUEST, GET_ZONE_RATE_REST, GET_ZONE_RATE_SUCCESS, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getZoneRateReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ZONE_RATE_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case GET_ZONE_RATE_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, error: null });
        case GET_ZONE_RATE_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case GET_ZONE_RATE_REST:
            return Object.assign(Object.assign({}, state), { loading: false, data: null });
        default:
            return state;
    }
};
export default getZoneRateReducer;
